import React from 'react';

const ErrorList = ({ errors }) => {
    const extractMessagesWithRefs = (obj) => {
        let items = [];

        for (const key in obj) {
            const error = obj[key];

            if (error?.message && error?.ref?.name) {
                items.push({ message: error.message, name: error.ref.name });
            } else if (typeof error === 'object') {
                items = items.concat(extractMessagesWithRefs(error));
            }
        }

        return items;
    };

    const errorItems = extractMessagesWithRefs(errors);

    const handleClick = (name) => {

        let element = document.querySelector(`[data-input-name="${name}"]`);
        if (!element) {
            element = document.querySelector(`[name="${name}"]`);
        }
        if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'center' });
            element.classList.add('scroll-highlight');
            setTimeout(() => element.classList.remove('scroll-highlight'), 2000);
        }
    };


    return (
        <>
            <style>
                {`
                .scroll-highlight {
                    animation: scrollHighlightFlash 2s ease;
                }

                @keyframes scrollHighlightFlash {
                    0% { box-shadow: 0 0 0 3px rgba(220, 53, 69, 0.8); }
                    50% { box-shadow: 0 0 0 6px rgba(220, 53, 69, 0.3); }
                    100% { box-shadow: none; }
                }
                `}
            </style>

            {errorItems.map(({ message, name }, idx) => (
                <span
                    key={idx}
                    className="badge text-danger-li"
                    style={{ cursor: 'pointer' }}
                    onClick={() => handleClick(name)}
                >
                    {message}
                </span>
            ))}
        </>
    );
};

export default ErrorList;
